export function Placeholder({ title }: { title: string }) {
  return (
    <section>
      <h2>{title}</h2>
      <p className="muted">Nothing here yet.</p>
    </section>
  );
}
